import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ProfileService } from '../../shared/services/profile.service';
import { PlayBoardService } from '../../shared/services/play-board.service';
import { Router, RouterModule } from '@angular/router';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { socket } from '../../shared/helpers/socketio';
import { LoginPopupComponent } from '../../shared/login-popup/login-popup.component';
import { FooterComponent } from '../../core/components/footer/footer.component';
import { DecryptionService } from '../../shared/services/decryption.service';
@Component({
  selector: 'app-home',
  standalone: true,
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    LoginPopupComponent,
    FooterComponent,
  ],
})
export class HomeComponent implements OnInit {
  ratingblitz: any;
  ratingbullet: any;
  ratingrapid: any;
  ratingpuzzles: any;
  form!: FormGroup;
  selectModeData: any;
  opponentWaiting: boolean = false;
  multiplayerGameDetails: any;
  profilesection = false;
  showAdvancedOptions = false;
  gamesection = true;
  puzzlesection = false;
  modalDisplayStyle!: boolean;
  selectedPiece: string = '';
  selectedtheme: string = '';
  playedGameUser: any;
  timeOptions: any = {
    bullet: ['1 Min', '1 Min | 1', '2 Min'],
    blitz: ['3 Min', '3 Min | 2', '5 Min'],
    rapid: ['10 Min', '15 Min', '30 Min'],
  };
  futureEvents: any[] = [
    {
      title: 'AI-Powered Coaching',
      description:
        'Personalized lessons and real-time advice based on your gameplay.',
      icon: '🎓',
    },
    {
      title: 'Tournaments',
      description:
        'Scheduled tournaments for all skill levels with FIDE integration.',
      icon: '🏆',
    },
    {
      title: 'Live Game Broadcasting',
      description: 'Watch top games live with expert commentary and analysis.',
      icon: '📺',
    },
    {
      title: 'Mobile App Integration',
      description: 'Seamlessly play on the go with our mobile companion app.',
      icon: '📱',
    },
    {
      title: 'Advanced Puzzle Challenges',
      description:
        'Solve themed puzzles with leaderboards and improve your tactics.',
      icon: '🧩',
    },
    {
      title: 'Opening Explorer',
      description: 'Analyze openings with statistics from Grandmaster games.',
      icon: '📊',
    },
    {
      title: 'Community Features',
      description: 'Join forums, chat rooms, and connect with other players.',
      icon: '💬',
    },
    {
      title: 'Leaderboard Expansion',
      description:
        'Explore detailed leaderboards with filters by country, age group, and more.',
      icon: '🏅',
    },
    {
      title: 'Board Analysis',
      description:
        'In-depth analysis of your games to help you understand your strengths and weaknesses.',
      icon: '🔍',
    },
    {
      title: 'Integration with Physical Chessboards',
      description:
        'Sync your online games with connected physical chessboards.',
      icon: '🔗',
    },
    {
      title: 'One-on-One Coaching',
      description:
        'Receive personalized coaching sessions tailored to your specific needs.',
      icon: '👤',
    },
    {
      title: 'Group Coaching',
      description:
        'Participate in group coaching sessions to improve your game with others.',
      icon: '👥',
    },
  ];
  showTimeOptions = false;
  availableTimes: number[] = [];
  boardColor: string = '';
  boardoddColor: string = '';

  constructor(
    private profileData: ProfileService,
    private playBoardService: PlayBoardService,
    private router: Router,
    private fb: FormBuilder,
    private decryptionApi: DecryptionService
  ) {
    setInterval(() => {
      this.tiles.forEach((tile: any) => {
        tile.flip = !tile.flip;
      });
    }, 3000);
    setInterval(() => {
      this.bullet.forEach((tile: any) => {
        tile.flip = !tile.flip;
      });
    }, 3000);
    setInterval(() => {
      this.rapid.forEach((tile: any) => {
        tile.flip = !tile.flip;
      });
    }, 3000);
    setInterval(() => {
      this.puzzles.forEach((tile: any) => {
        tile.flip = !tile.flip;
      });
    }, 3000);
  }

  switchState: boolean = true;
  userData: any;
  myHighestRating: any;
  myRating: any;
  tiles: any = [
    {
      blitz: {},
      flip: false,
      winrate: 0,
    },
  ];
  bullet: any = [
    {
      bullet: {},
      flip: false,
      winrate: 0,
    },
  ];
  rapid: any = [
    {
      rapid: {},
      flip: false,
      winrate: 0,
    },
  ];
  puzzles: any = [
    {
      puzzles: {},
      flip: false,
    },
  ];
  ngOnInit(): void {
    let currentUser = JSON.parse(localStorage.getItem('loggedInUser') || '{}');
    if (currentUser.username) {
      this.gamedetails();

      this.initializeForm();

      this.loadFormValues();

      const savedValues = JSON.parse(localStorage.getItem('boardPieces') || '');
      this.selectedPiece = savedValues.pieces;
      this.boardColor = savedValues.white;
      this.boardoddColor = savedValues.black;
      this.selectedtheme = savedValues.theme;
      this.profiledetails();
      this.tilesData();
      const boardStyleControl = this.form.get('boardStyle');
      if (boardStyleControl) {
        boardStyleControl.valueChanges.subscribe((value) => {
          this.saveFormValue('boardStyle', value);
        });
      }

      const pieceStyleControl = this.form.get('pieceStyle');
      if (pieceStyleControl) {
        pieceStyleControl.valueChanges.subscribe((value) => {
          this.saveFormValue('pieceStyle', value);
        });
      }
    }

    socket.on('matched', (data: any) => {
      localStorage.setItem('gameIdreponse', JSON.stringify(data));
      this.multiplayerGameDetails = data;
      if (this.multiplayerGameDetails) {
        this.router
          .navigate(['play', this.multiplayerGameDetails?.gameId])
          .then(() => {
            // window.location.reload();
          });
      }
    });

    this.profileData.homePageRoute(true);
  }

  gamedetails() {
    let currentUser = JSON.parse(localStorage.getItem('loggedInUser') || '{}');
    this.profileData
      .profileGameData(currentUser.username, 1, 'all', 'descendingDate')
      .subscribe((data: any) => {
        const decrypt = this.decryptionApi.decrypt(data.payload);
        const jsondecrpt = JSON.parse(decrypt);
        this.playedGameUser = jsondecrpt;

        this.form.controls['selectedMode'].setValue(
          this.playedGameUser.games[0].gameMode
        );

        this.form.controls['selectedTime'].setValue(
          this.playedGameUser.games[0].time
        );

        this.form.controls['switchState'].setValue(
          this.playedGameUser.games[0].rated
        );
      });
  }

  saveFormValue(key: string, value: any) {
    const savedValues = JSON.parse(localStorage.getItem('boardPieces') || '');
    savedValues[key] = value;

    localStorage.setItem('boardPieces', JSON.stringify(savedValues));
  }

  loadFormValues() {
    const savedValues = JSON.parse(localStorage.getItem('boardPieces') || '');
    if (savedValues) {
      this.form.patchValue({
        boardStyle: savedValues.theme || '',
        pieceStyle: savedValues.pieces || '',
      });

      this.selectedtheme = savedValues.theme || '';
      this.selectedPiece = savedValues.pieces || '';
    }
  }

  initializeForm() {
    this.form = this.fb.group(
      {
        selectedMode: ['', Validators.required],
        selectedTime: ['', Validators.required],
        selectedTurn: [''],
        switchState: [['', Validators.required]],
        minRating: [''],
        maxRating: [''],
        boardStyle: [''],
        pieceStyle: [''],
        moveSounds: [false],
        visibility: ['public'],
      },
      { validator: this.ratingRangeValidator }
    );
    setTimeout(() => {
      this.onModeChange();
    }, 500);
  }

  loggedin() {
    return localStorage.getItem('loggedInUser');
  }

  ratingRangeValidator(group: FormGroup) {
    const minRating = group.get('minRating')?.value;
    const maxRating = group.get('maxRating')?.value;

    if (minRating === null && maxRating === null) {
      return { ratingRangeRequired: true };
    }

    if (minRating === null || maxRating === null) {
      return { ratingRangeInvalid: true };
    }

    return minRating <= maxRating ? null : { ratingRangeInvalid: true };
  }

  profiledetails() {
    this.profileData
      .settingprofileData(
        JSON.parse(localStorage.getItem('loggedInUser') || '{}').username
      )
      .subscribe((res: any) => {
        const decrypt = this.decryptionApi.decrypt(res.payload);
        const jsondecrpt = JSON.parse(decrypt);
        this.userData = jsondecrpt;
        this.tiles[0].winrate =
          (jsondecrpt.ratings.blitz.record.win /
            (jsondecrpt.ratings.blitz.record.draw +
              jsondecrpt.ratings.blitz.record.loss +
              jsondecrpt.ratings.blitz.record.win)) *
          100;

        this.bullet[0].winrate =
          (jsondecrpt.ratings.bullet.record.win /
            (jsondecrpt.ratings.bullet.record.draw +
              jsondecrpt.ratings.bullet.record.loss +
              jsondecrpt.ratings.bullet.record.win)) *
          100;

        this.rapid[0].winrate =
          (jsondecrpt.ratings.rapid.record.win /
            (jsondecrpt.ratings.rapid.record.draw +
              jsondecrpt.ratings.rapid.record.loss +
              jsondecrpt.ratings.rapid.record.win)) *
          100;
      });
  }

  profileDetails(username: string) {
    this.router.navigate(['/profile', username]);
  }

  toggleAdvancedOptions(): void {
    this.showAdvancedOptions = !this.showAdvancedOptions;
  }

  tilesData() {
    this.playBoardService.myrankingData('blitz').subscribe((res: any) => {
      const decrypt = this.decryptionApi.decrypt(res.payload);
      const jsondecrpt = JSON.parse(decrypt);
      this.tiles[0].blitz = jsondecrpt[0];
    });
    this.playBoardService.myrankingData('bullet').subscribe((res: any) => {
      const decrypt = this.decryptionApi.decrypt(res.payload);
      const jsondecrpt = JSON.parse(decrypt);
      this.bullet[0].bullet = jsondecrpt[0];
    });
    this.playBoardService.myrankingData('rapid').subscribe((res: any) => {
      const decrypt = this.decryptionApi.decrypt(res.payload);
      const jsondecrpt = JSON.parse(decrypt);
      this.rapid[0].rapid = jsondecrpt[0];
    });
    this.playBoardService.myrankingData('puzzle').subscribe((res: any) => {
      const decrypt = this.decryptionApi.decrypt(res.payload);
      const jsondecrpt = JSON.parse(decrypt);
      this.puzzles[0].puzzles = jsondecrpt[0];
    });
  }

  profilememberDetails(username: string) {
    this.router.navigate(['/profile', username]);
  }

  onModeChange(): void {
    const selectedMode = this.form.get('selectedMode')?.value;

    this.availableTimes = selectedMode
      ? this.timeOptions[selectedMode] || []
      : [];

    this.showTimeOptions = selectedMode && !!this.availableTimes.length;

    if (
      this.playedGameUser.games[0]?.time &&
      this.availableTimes.includes(this.playedGameUser.games[0].time)
    ) {
      this.form.patchValue({
        selectedTime: this.playedGameUser.games[0].time,
      });
    } else {
      this.form.patchValue({
        selectedTime: null, // Reset the selectedTime to null or a default value
      });
    }
  }

  toggleSwitch(checked: any) {
    this.switchState = checked.checked;
  }

  onSubmit(data: any) {
    this.themeselect(data);
    this.selectModeData = data;
    this.opponentWaiting = true;
    const ratingModeMap: any = {
      bullet: this.userData?.bullet?.last?.rating,
      blitz: this.userData?.blitz?.last?.rating,
      rapid: this.userData?.rapid?.last?.rating,
    };

    const ratings = ratingModeMap[data.selectedMode];

    const formData = {
      gameMode: data.selectedMode,
      time: data.selectedTime,
      playedAS: data.selectedTurn,
      rating: ratings,
      username: this.userData.username,
      minRating: data.minRating,
      maxRating: data.maxRating,
      ratedGame: data.switchState,
    };

    localStorage.setItem('moveSounds', JSON.stringify(data.moveSounds));
    socket.emit('joinMatchmaking', formData);
  }

  multiplayerclose() {
    const formData = {
      gameMode: this.selectModeData.mode,
      time: this.selectModeData.selectedTime,
      username: this.userData.username,
    };

    this.opponentWaiting = false;
    socket.emit('cancelMatchMaking', formData);
  }

  gamesectiondata() {
    this.gamesection = true;
    this.profilesection = false;
  }
  profilesectiondata() {
    this.gamesection = false;
    this.profilesection = true;
  }

  GetChildData(data: any) {
    this.modalDisplayStyle = data;
  }

  loginuser() {
    this.modalDisplayStyle = true;
  }

  themeselect(data: any) {
    const themeColors: any = {
      BI: { boardColor: '#ffffff', boardoddColor: '#6e8faf' },
      Classic: { boardColor: '#f0d9b5', boardoddColor: '#b58863' },
      Barbie: { boardColor: '#f9dddd', boardoddColor: '#ec8dc0' },
      'Urban Slate': { boardColor: '#767474', boardoddColor: '#413e3e' },
      dr: { boardColor: '#fff8ad', boardoddColor: '#c46464' },
      Froggy: { boardColor: '#fff8ad', boardoddColor: '#64c46f' },
      green: { boardColor: '#EBECD0', boardoddColor: '#739552' },
      'Mint Breeze': { boardColor: '#b6f0b2', boardoddColor: '#7498be' },
      'Cranberry Mist': { boardColor: '#b8b8b8', boardoddColor: '#8d4444' },
      cs: { boardColor: '#f7b0b0', boardoddColor: '#62a1df' },
      ts: { boardColor: '#E9ECF0', boardoddColor: '#B5BDCE' },
      eo: { boardColor: '#3dffd8', boardoddColor: '#5d58ad' },
      Av: { boardColor: '#88fbf9', boardoddColor: '#a18c78' },
    };

    this.boardColor = themeColors[data.boardStyle]?.boardColor;
    this.boardoddColor = themeColors[data.boardStyle]?.boardoddColor;

    document.documentElement.style.setProperty(
      '--local-storage-oddcolor',
      this.boardColor
    );
    document.documentElement.style.setProperty(
      '--local-storage-color',
      this.boardoddColor
    );
    let BoardPiece = {
      pieces: data.pieceStyle,
      theme: data.boardStyle,
      white: this.boardColor,
      black: this.boardoddColor,
    };

    localStorage.setItem('boardPieces', JSON.stringify(BoardPiece));
    this.profileData.boardPiecedata({ boardAndPieces: BoardPiece }).subscribe({
      next: (res) => {},
    });
  }
}
